import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { Container, Grid, Typography, Button, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";

import BePartOfKids from "../../assets/images/BePartOfKids.png";
import ParentsVideo from "../../assets/images/ParentsVideo.png";
// import TeacherVideo from "../../assets/images/TeacherVideo.png";
import RealTimeUpdates from "../../assets/images/RealTimeUpdates.png";
import MemoryArchive from "../../assets/images/MemoryArchive.png";
import InstantMessagingP5 from "../../assets/images/InstantMessagingP5.png";
import ImmunisationRecord from "../../assets/images/ImmunisationRecord.png";
import SharingWithFamily from "../../assets/images/SharingWithFamily.png";
import RedCircle from "../../assets/images/RedCircle.png";
import ChildPreciousMoment from "../../assets/images/ChildPreciousMoment.png";
import owner_youtube from "../../assets/images/owner_youtube.png";
import Active from "../../assets/images/Active.png";
import InviteFamilyAndFriends from "../../assets/images/InviteFamilyAndFriends.png";
import DoubleBlueColorCircle from "../../assets/images/DoubleBlueColorCircle.png";
import PlayIcon from "../../assets/images/PlayIcon.png";
import ParentsVideo22 from "../../assets/images/ParentsVideo22.png";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "0px 30px",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },

  banner: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
      marginTop: 10,
    },
  },

  banner_image: {
    flex: 1,
    padding: 30,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  banner_content: {
    flex: 1,
    padding: 30,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: 20,
    },
  },
  banner_button: {
    padding: "13px 35px  !important",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 10,
      padding: "7px 16px  !important",
    },
  },

  banner_content_text: {
    fontSize: 24,
    marginBottom: 30,
    [theme.breakpoints.down("xs")]: {
      fontSize: 18,
    },
  },
  banner_headline: {
    fontWeight: 600,
    marginBottom: 80,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 40,
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: 20,
      fontSize: "2rem",
    },
  },
  margin_left_20: {
    marginLeft: 20,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 3,
      marginBottom: 10,
    },
  },
  wrapper2: {
    marginTop: 120,
    padding: "120px 120px 60px 120px",
    width: "100%",
    background: "#E3EBFC",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      padding: "90px 120px 60px 120px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "70px  0 0 0",
      marginTop: 50,
    },
  },
  card: {
    position: "absolute",
    // zIndex: 9,
    display: "flex",
    width: "700px",
    left: "calc(50% - 350px)",
    top: -80,
    [theme.breakpoints.down("sm")]: {
      width: "560px",
      left: "calc(50% - 280px)",
    },
    [theme.breakpoints.down("xs")]: {
      // display: "none",
      width: "310px",
      left: "calc(50% - 155px)",
      top: -38,
    },
  },
  right: {
    flex: 1,
    boxSizing: "border-box",
    padding: "20px 25px",
    [theme.breakpoints.down("xs")]: {
      padding: "10px",
    },
  },
  left: {
    // backgroundImage: `url(${DirectorDemoVideo})`,
    // backgroundSize: "cover",
    width: 300,
    "& img": {
      width: "100%",
      height: "100%",
    },
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: 240,
    },
    [theme.breakpoints.down("xs")]: {
      width: 120,
    },
  },
  right_text: {
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
    },
  },
  play: {
    color: "#0B4295",
    padding: "13px 0px  !important",
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      padding: "3px 0px  !important",
      fontSize: "12px !important",
      "& svg": {
        fontSize: "16px !important",
      },
    },
  },
  // wrapper2: {
  //   marginTop: 120,
  //   padding: "120px 120px 60px 120px",
  //   width: "100%",
  //   background: "#E3EBFC",
  //   position: "relative",
  //   [theme.breakpoints.down("xs")]: {
  //     padding: 0,
  //     marginTop: 10,
  //   },
  // },
  // card: {
  //   position: "absolute",
  //   zIndex: 9,
  //   display: "flex",
  //   width: "700px",
  //   left: "calc(50% - 350px)",
  //   top: -80,
  //   [theme.breakpoints.down("sm")]: {
  //     width: "560px",
  //     left: "calc(50% - 280px)",
  //   },
  //   [theme.breakpoints.down("xs")]: {
  //     display: "none",
  //   },
  // },
  // left: {
  //   backgroundImage: `url(${ParentsVideo})`,
  //   backgroundSize: "cover",
  //   width: 300,
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   [theme.breakpoints.down("sm")]: {
  //     width: 240,
  //   },
  // },
  // right: {
  //   padding: "20px 25px",
  //   [theme.breakpoints.down("sm")]: {
  //     fontSize: 16,
  //   },
  // },
  // right_text: {
  //   fontSize: 20,
  //   [theme.breakpoints.down("sm")]: {
  //     fontSize: 16,
  //   },
  // },
  // play: {
  //   color: "#0B4295",
  //   padding: "13px 0px  !important",
  //   [theme.breakpoints.down("xs")]: {
  //     marginLeft: 0,
  //   },
  // },
  activity_box: {
    textAlign: "center",
    padding: "15px",
    [theme.breakpoints.down("xs")]: {
      marginBottom: 15,
    },
  },

  activity_image: {
    maxWidth: "100%",
    background: `url(${RedCircle})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    padding: 25,
    marginBottom: 15,
    [theme.breakpoints.down("sm")]: {
      backgroundSize: "70px",
      width: "86px",
    },
  },

  activity_headline: {
    padding: 10,
  },
  activity_wrapper: {
    padding: "60px 120px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 0px",
    },
  },
  activity_wrapper2: {
    padding: "60px 120px 0px 120px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 0px",
    },
  },
  activity_wrapper5: {
    padding: "60px 120px 0px 120px",
    [theme.breakpoints.down("xs")]: {
      padding: "0px",
    },
  },
  activity_wrapper3: {
    padding: "20px 120px 0px 120px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 0px",
      maxWidth: "90%",
      margin: "auto",
    },
  },
  activity_wrapper4: {
    padding: "100px 120px 100px 120px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 0px",
    },
  },
  h4: {
    marginBottom: "40px",
  },
  h6: {
    marginTop: 0,
  },
  align_left: {
    textAlign: "left",
  },
  margin_bottom_30: {
    marginBottom: 30,
  },
  image: {
    maxWidth: "100%",
  },
  image3: {
    maxWidth: "100%",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      display: "block",
      margin: "auto",
    },
  },
  image2: {
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "220px",
      // margin: "auto",
      // display:"block"
    },
  },
  parent_child: {
    display: "flex",
    justifyContent: "center",
  },
  // tag: {
  //   textAlign: "center",
  //   background: "#E3EBFC",
  //   borderRadius: 13,
  //   padding: "40px 20px",
  //   margin: 15,
  //   "& h3": {
  //     fontWeight: 600,
  //     marginBottom: 10,
  //   },
  // },

  // tag_text: {
  //   marginTop: -10,
  // },
  tag: {
    textAlign: "center",
    background: "#E3EBFC",
    borderRadius: 13,
    padding: "40px 20px",
    margin: 15,
    "& h3": {
      fontWeight: 600,
      marginBottom: 10,
    },
    [theme.breakpoints.down("sm")]: {
      margin: "0px 60px",
    },
  },

  tag_text: {
    marginTop: -10,
  },
  center: {
    textAlign: "center",
  },

  title_bg: {
    background: `url(${DoubleBlueColorCircle})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "30% 50%",
    backgroundSize: "9%",
  },
  title_bg2: {
    background: `url(${DoubleBlueColorCircle})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "70% 50%",
    backgroundSize: "7%",
  },
}));

const Parents = () => {
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Container maxWidth="lg">
        <Grid container className={classes.wrapper}>
          <Grid item lg={12} md={12}>
            <div className={classes.banner}>
              <div className={classes.banner_content}>
                <Typography variant="h3" className={classes.banner_headline}>
                  Be part of kids
                </Typography>
                <Typography className={classes.banner_content_text}>
                  Stay in touch with your kid’s educational journey with our
                  KinderCubby platform.
                </Typography>
                <div>
                  <Link to="/request-call">
                    <Button
                      variant="contained"
                      color="primary"
                      className={`${classes.banner_button} button`}
                    >
                      Contact Sales
                    </Button>
                  </Link>
                  <Link to="/try-it-free">
                    <Button
                      variant="outlined"
                      color="primary"
                      className={`${classes.banner_button} ${classes.margin_left_20} button`}
                    >
                      Start free trial
                    </Button>
                  </Link>
                </div>
              </div>
              <div className={classes.banner_image}>
                <img src={BePartOfKids} alt="" />
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg">
        <Grid container className={classes.wrapper2}>
          <Card className={classes.card}>
            <div className={classes.left}>
              <img src={ParentsVideo22} alt="" />
            </div>
            <div className={classes.right}>
              <Typography className={classes.right_text}>
                See what directors are saying about KinderCubby
              </Typography>
              <Button
                // variant="contained"
                color="secondary"
                className={`${classes.play} button`}
                startIcon={<PlayCircleOutlineIcon />}
              >
                Watch In Action
              </Button>
            </div>
          </Card>
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.activity_headline}>
              Innovation for worried parents
            </Typography>
          </Grid>
          <Grid item lg={4} md={4} className={classes.activity_box}>
            <img
              className={classes.activity_image}
              src={RealTimeUpdates}
              alt=""
            />
            <div>
              <Typography variant="h5">Real-time updates</Typography>
              <Typography variant="subtitle1">
                Get instantaneous updates about your child’s performance,
                behvaior, and attendance at childcare.
              </Typography>
            </div>
          </Grid>
          <Grid item lg={4} md={4} className={classes.activity_box}>
            <img
              className={classes.activity_image}
              src={MemoryArchive}
              alt=""
            />
            <div>
              <Typography variant="h5">Memory archive</Typography>
              <Typography variant="subtitle1">
                Create a memory archive that stores your child’s photos, A+
                assignments, and good deeds.
              </Typography>
            </div>
          </Grid>
          <Grid item lg={4} md={4} className={classes.activity_box}>
            <img
              className={classes.activity_image}
              src={InstantMessagingP5}
              alt=""
            />
            <div>
              <Typography variant="h5">Instant Messaging</Typography>
              <Typography variant="subtitle1">
                Instantly connect with your child’s teacher if you have a
                question, concer, or simply want to check-in.
              </Typography>
            </div>
          </Grid>
          <Grid container className={classes.activity_second}>
            <Grid item lg={6} md={6} className={classes.activity_box}>
              <img
                className={classes.activity_image}
                src={ImmunisationRecord}
                alt=""
              />
              <div>
                <Typography variant="h5">Immunisation record</Typography>
                <Typography variant="subtitle1">
                  Update and store your kid’s immunisation records in our
                  system. Keeping all of your health needs in one place to
                  remain compliant.
                </Typography>
              </div>
            </Grid>
            <Grid item lg={6} md={6} className={classes.activity_box}>
              <img
                className={classes.activity_image}
                src={SharingWithFamily}
                alt=""
              />
              <div>
                <Typography variant="h5">Sharing with family</Typography>
                <Typography variant="subtitle1">
                  Receive photos of your child playing with others or learning
                  in daycare and share them with your entire family.
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg">
        <Grid container spacing={3} className={`${classes.activity_wrapper2}`}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="h4" className={classes.title_bg}>
              Never miss you child’s
              <br /> Precious moments
            </Typography>
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className={classes.parent_child}
          >
            <img src={ChildPreciousMoment} alt="" className={classes.image2} />
          </Grid>
          <Grid item lg={6} md={6}>
            <Typography variant="h5" className={classes.align_left}>
              Attendance update
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.margin_bottom_30}
            >
              Know if your child is where they should be. Ensure that they are
              checked-in and attending daycare appropriately.
            </Typography>

            <Typography variant="h5" className={classes.align_left}>
              Activity Feed
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.margin_bottom_30}
            >
              Monitor the activities, learning opportunities, and assignments
              that your child completes at home and at childcare.
            </Typography>

            <Typography variant="h5" className={classes.align_left}>
              Incident Reports
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.margin_bottom_30}
            >
              Be notified if your child causes trouble. Receive an incident
              report and schedule a meeting to talk about improvement for the
              future.
            </Typography>

            <Typography variant="h5" className={classes.align_left}>
              Photos & videos
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.margin_bottom_30}
            >
              Have teachers and assistants keep you updated with photos and
              videos of your child interacting throughout the day.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg">
        <Grid
          container
          justify="center"
          alignItems="center"
          spacing={3}
          className={`${classes.activity_wrapper5}`}
        >
          <Grid item lg={12} md={12}>
            <Typography variant="h4" className={classes.title_bg2}>
              Going a little extra miles
            </Typography>
          </Grid>
          <Grid item lg={6} md={6} className={classes.parent_child}>
            <img src={Active} alt="" className={classes.image} />
          </Grid>
          <Grid item lg={6} md={6}>
            <Typography variant="h5" className={classes.align_left}>
              Pickup authorisation
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.margin_bottom_30}
            >
              Authorize the appropriate personnel to have your child dropped off
              and picked up from daycare.
            </Typography>
          </Grid>
          <Grid item lg={6} md={6}>
            <Typography variant="h5" className={classes.align_left}>
              Onboarding the whole crew
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.margin_bottom_30}
            >
              Get all of your involved family members enrolled under one profile
              on our KinderCubby platform to ensure a notification doesn’t get
              missed.
            </Typography>
          </Grid>
          <Grid item lg={6} md={6} className={classes.parent_child}>
            <img
              src={InviteFamilyAndFriends}
              alt=""
              className={classes.image}
            />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg">
        <div className={`${classes.activity_wrapper3}`}>
          <Grid container justify="center" alignItems="center" spacing={5}>
            <Grid item lg={12} md={12}>
              <Typography variant="h4" className={classes.h4}>
                Impact of KinderCubby on parents
              </Typography>

              <img src={owner_youtube} alt="" className={classes.image3} />
            </Grid>

            {/* <Grid item lg={4} md={4}>
            <div className={classes.tag}>
              <Typography variant="h3">85%</Typography>
              <Typography variant="h5">of users</Typography>
              <Typography variant="body1" className={classes.tag_text}>
                Would recommend KinderCubby
              </Typography>
            </div>
          </Grid>

          <Grid item lg={4} md={4}>
            <div className={classes.tag}>
              <Typography variant="h3">100%</Typography>
              <Typography variant="h5">of users</Typography>
              <Typography variant="body1" className={classes.tag_text}>
                Are satisfied with the experience
              </Typography>
            </div>
          </Grid>
          <Grid item lg={4} md={4}>
            <div className={`${classes.tag} `}>
              <Typography variant="h3">10+</Typography>
              <Typography variant="h5">of users</Typography>
              <Typography variant="body1" className={classes.tag_text}>
                Kid moments have been recorded
              </Typography>
            </div>
          </Grid> */}
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <div className={classes.tag}>
                <Typography variant="h3">85%</Typography>
                <Typography variant="h5">of users</Typography>
                <Typography variant="body1" className={classes.tag_text}>
                  Would recommend KinderCubby
                </Typography>
              </div>
            </Grid>

            <Grid item lg={4} md={4} sm={12} xs={12}>
              <div className={classes.tag}>
                <Typography variant="h3">100%</Typography>
                <Typography variant="h5">of users</Typography>
                <Typography variant="body1" className={classes.tag_text}>
                  Are satisfied with the experience
                </Typography>
              </div>
            </Grid>
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <div className={`${classes.tag} `}>
                <Typography variant="h3">10+</Typography>
                <Typography variant="h5">of users</Typography>
                <Typography variant="body1" className={classes.tag_text}>
                  Kid moments have been recorded
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>

      <Container maxWidth="lg">
        <Grid container className={`${classes.activity_wrapper4}`}>
          <Grid item lg={12} md={12}>
            <Typography variant="h4">Invite your school</Typography>
            <Typography variant="h6" className={classes.h6}>
              Get connected with our KinderCubby team today and setup your
              established or new childcare center with our system. Watch as we
              transform your daycare into a true digital experience fit for
              everyone.
            </Typography>
            <div className={classes.center}>
              <Link to="/try-it-free">
                <Button
                  variant="contained"
                  color="primary"
                  className={`${classes.banner_button} button`}
                >
                  Try it Free
                </Button>
              </Link>
              <Link to="pricing">
                <Button
                  variant="outlined"
                  color="primary"
                  className={`${classes.banner_button} ${classes.margin_left_20} button`}
                >
                  Explore Pricing
                </Button>
              </Link>
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Parents;
